export const environment = {
  url: '/',
  production: false,
  options: {
    headerScrollTop : 80,
    headerFluid : false
  },
  mapbox: {
    accessToken: 'pk.eyJ1IjoiaW5vdmVyIiwiYSI6ImNqeTdoNmJkNzAwZW4zaXFmYzI5c3Foam8ifQ.RqMKtMZkpemXqRN4oLdDog' 
  }
};
